<template>
  <div>
    <div class="justifiy-content-center">
      <h2>Cusotmer一覧</h2>
    </div>
    <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
    <div>
      <v-data-table
        :headers="headers"
        :items="customers"
        :item-key="customers.ID"
        @click:row="modalOpen"
        :items-per-page="-1"
      >
      </v-data-table>
      <td>
        <v-dialog v-if="dialog" v-model="dialog">
          <CustomerJoinForm
            v-on:clickSubmit="modalClose"
            :data="data"
          ></CustomerJoinForm>
        </v-dialog>
      </td>
    </div>
  </div>
</template>

<script>
import CustomerJoinForm from "../../components/UserSetting/CustomerJoinForm";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");
export default {
  components: {
    CustomerJoinForm,
  },
  data: () => ({
    //data: {},
    customers: [],
    dialog: false,
  }),
  async mounted() {
    await this.getInit();
  },
  methods: {
    async getInit() {
      //初期処理
      this.isLoading = true;
      this.customers = await api.getAllCustomer();
      this.customers.forEach((value) => {
        value.dialog = false;
      });
      //読み込み終了
      this.isLoading = false;
    },
    modalOpen(row) {
      console.log(row);
      this.data = row;
      this.dialog = true;
    },
    modalClose() {
      this.data = null;
      this.dialog = false;
    },

    back() {
      history.back();
    },
  },
  computed: {
    headers() {
      return [
        { text: "ID", value: "ID", align: "start", sortable: true },
        { text: "customer名", value: "name" },
        { text: "詳細", value: "detail" },
      ];
    },
  },
};
</script>

<style lang="stylus"></style>
